import { BookOfMindQuote } from "motw_core/DTOs/BookOfMindQuote";
import { IDataProvider } from "motw_core/Data/IDataProvider";
import { IWorkflowNode } from "./../Entity/IWorkflowNode";
import {
    fromOthersNodeName,
    homeNode,
    workflowRepository,
} from "./WorkflowRepository";

class BookOfMindRepository {
    async GetBookOfMindQuotesAsync(
        dataProvider: IDataProvider,
        rootNodeName: string | undefined
    ) {
        let quotesParentNode = rootNodeName
            ? await workflowRepository.GetNodeByNameAsync(
                  dataProvider,
                  rootNodeName
              )
            : await workflowRepository.GetBookOfMindRootNodeAsync(dataProvider);

        if (!quotesParentNode && rootNodeName === fromOthersNodeName) {
            quotesParentNode = await workflowRepository.GetBookOfMindRootNodeAsync(
                dataProvider
            );
        }

        if (!quotesParentNode) {
            console.warn(
                `Could not find Book of Mind root node: ${rootNodeName}`
            );
            return [];
        }

        const childNodes = await workflowRepository.GetAllChildrenAsync(
            quotesParentNode,
            dataProvider
        );

        const sortedQuoteNodes = childNodes
            .filter((node) => this.IsQuotableNode(node, childNodes))
            .sort((a, b) => a.id - b.id);

        bookOfMindRepository.LogProblemQuotes(sortedQuoteNodes);

        var quotes = await Promise.all(
            sortedQuoteNodes.map(async (node) => {
                const quoteParent = this.GetQuoteParent(node, childNodes);
                return new BookOfMindQuote(
                    node.name,
                    quoteParent,
                    node.id,
                    node.lastmodifiedtime
                );
            })
        );

        return quotes;
    }

    IsQuotableNode(node: IWorkflowNode, allNodesCached: IWorkflowNode[]) {
        const minimumQuoteLength = 20;
        const doesMeetMinLength = node.name.length >= minimumQuoteLength;

        const result =
            bookOfMindRepository.HasNoChildren(node, allNodesCached) &&
            doesMeetMinLength;

        return result;
    }

    HasNoChildren(node: IWorkflowNode, cachedAllNodes: IWorkflowNode[]) {
        const numberOfChildren = cachedAllNodes.filter(
            (n) => n.parentid === node.id
        ).length;

        return numberOfChildren === 0;
    }

    LogProblemQuotes(nodes: IWorkflowNode[]) {
        if (nodes.length === 0) {
            return;
        }

        const problemQuotes = nodes.filter((node) => {
            const quote = node.name;
            const lastCharacter = quote.slice(-1);

            return (
                quote.length >= 20 &&
                lastCharacter !== "." &&
                lastCharacter !== `?`
            );
        });

        const nodeIds = problemQuotes.map((node) => node.id);

        if (nodeIds.length) {
            console.log(
                `Please add periods to these workflow nodes: ${nodeIds}`
            );
        }
    }

    public GetQuoteParent = (
        quoteNode: IWorkflowNode,
        cachedAllNodes: IWorkflowNode[]
    ) => {
        const parentNode = bookOfMindRepository.GetParentNode(
            quoteNode,
            cachedAllNodes
        );

        const parentNodeName = parentNode ? parentNode.name : "";
        return parentNodeName;
    };

    GetParentNode(
        rootNode: IWorkflowNode,
        cachedAllNodes: IWorkflowNode[]
    ): IWorkflowNode | undefined {
        const parentId = rootNode.parentid;

        const parentNode =
            parentId === 0
                ? homeNode
                : cachedAllNodes.find((node) => node.id === rootNode.parentid)!;

        return parentNode;
    }
}

export const bookOfMindRepository = new BookOfMindRepository();
